export enum QuestionType {
  DESCRIPTION = 'TYPE_DESCRIPTION',
  OPEN = 'TYPE_OPEN',
  CHECKBOX = 'TYPE_CHECKBOX',
  MULTIPLE_CHOICE = 'TYPE_MULTIPLE_CHOICE',
  RANGE = 'TYPE_RANGE',
}
